export class ApiError extends Error {
  constructor(public status: number, message: string, public body?: unknown) {
    super(message);
  }
}

function getCookie(name: string): string | undefined {
  const match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[2]) : undefined;
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (!headers.has('Content-Type') && init.body && !(init.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }
  const xsrf = getCookie('XSRF-TOKEN');
  if (xsrf) headers.set('X-XSRF-TOKEN', xsrf);

  const bearer = sessionStorage.getItem('access_token');
  if (bearer) headers.set('Authorization', `Bearer ${bearer}`);

  const res = await fetch(path, { credentials: 'include', ...init, headers });
  if (!res.ok) {
    let body: unknown;
    try { body = await res.json(); } catch { body = await res.text().catch(() => undefined); }
    throw new ApiError(res.status, `Request failed: ${res.status}`, body);
  }
  if (res.status === 204) return undefined as T;
  const contentType = res.headers.get('content-type') ?? '';
  if (contentType.includes('application/json')) return (await res.json()) as T;
  return (await res.text()) as unknown as T;
}

export const apiClient = {
  get: <T,>(path: string) => api<T>(path),
  post: <T,>(path: string, body: unknown) => api<T>(path, { method: 'POST', body: JSON.stringify(body) }),
  postForm: <T,>(path: string, form: FormData) => api<T>(path, { method: 'POST', body: form }),
  put: <T,>(path: string, body: unknown) => api<T>(path, { method: 'PUT', body: JSON.stringify(body) }),
  del: <T,>(path: string) => api<T>(path, { method: 'DELETE' })
};
